var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-[#DC2828] text-[14px] font-normal leading-[20px] cursor-pointer",on:{"click":function($event){$event.preventDefault();return _vm.deletePurchaseItemDetail.apply(null, arguments)}}},[_vm._v(" Delete ")])}
var staticRenderFns = []

export { render, staticRenderFns }